import styled from 'styled-components';

export const Th = styled.th`
  padding-top: 10px;
  vertical-align: middle;
  background: #4b286d;
  color: #fff;
  & * { color: #fff !important; }
`;

export const Td = styled.td`
  border: 1px solid #e3e3e3;
  vertical-align: middle;
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  text-align: ${props => props.textAlign || 'left'};
`;

export const Tr = styled.tr`
  /* border-top: ${props => (props.border ? '1px solid #000' : '')}; */
`;

export const Button = styled.div`
  margin-right: 20px;
`;

export const customStyles = `
  overflow: auto;
  max-height: 75vh;
  padding-top: 1.25rem;
  padding-bottom: 0;
  background-color: white;`;

export const Search = styled.div`
  display: flex;
  justify-content: flex-end; /* align its own children to the right */
  margin-left: auto;
  flex-direction: row;
  padding: 16px 6rem 16px 0;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;

export const ModalFieldLabel = styled.div`
  font-size: 1rem;
  margin-bottom: 4px;
  margin-top: 10px;
`;

// T005/T006 [US1]: Tab container and tab button with active-bold styling
export const TabContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #4b286d;
  margin: 8px 0 16px 0;
`;

export const TabBtn = styled.button`
  padding: 8px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1rem;
  font-weight: ${props => (props.active ? 'bold' : 'normal')};
  color: ${props => (props.active ? '#4b286d' : '#333')};
  border-bottom: ${props => (props.active ? '3px solid #4b286d' : '3px solid transparent')};
  margin-bottom: -2px;
  &:focus {
    outline: 2px solid #4b286d;
    outline-offset: 2px;
  }
`;

// export const ModalFooter = styled.div`
//   width: 100%;
//   display: flex;
//   align-items: flex-end;
//   justify-content: flex-end;
//   margin-top: 20px;
//   gap: 12px;
// `;

export const ModalFooter = styled.div`
  position: sticky;
  bottom: 0;                   /* stick to bottom of the modal content area */
  background: #fff;            /* give it a background so content doesn't show through */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 8px 16px 8px 16px;   /* reduced vertical padding so Add button sits closer to bottom */
  border-top: 2px solid #4b286d;  /* optional separator line */
  z-index: 10;                 /* ensure it sits above scrollable content */
`;